/**
 *  Filename ....: agencies.component.ts
 *  Created by ..: ianday
 *  on Date .....: 9/27/23
 **/
import {Component, OnInit} from '@angular/core';
import {Settings} from "../../services/settings";

@Component({
    selector: 'app-agencies',
    templateUrl: './agencies.component.html',
    styleUrls: ['./agencies.component.css']
})

export class AgenciesComponent implements OnInit {

    public visibleAgencyDefinition = false;
    public visibleServiceSummary = false;
    public visibleServiceDefinition = false;
    public visibleCustomQualifications = false;
    public visibleMessageSuffixes = false;

    public visibleAgencyDefinitionLink = false;
    public visibleServiceSummaryLink = false;
    public visibleServiceDefinitionLink = false;
    public visibleCustomQualificationsLink = false;
    public visibleMessageSuffixesLink = false;

    constructor() {

    }

    ngOnInit() {

        if(Settings.getInstance().hasPrivilege('AGENCY_DETAILS', "EXECUTE") || Settings.getInstance().hasPrivilege('AGENCY_DETAILS', "READ")) {
            this.visibleAgencyDefinitionLink = true;
            //this.visibleServiceSummaryLink = true;        
        }
        if(Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEFS', "EXECUTE") || Settings.getInstance().hasPrivilege('AGENCY_SERVICE_DEFS', "READ")) {
            this.visibleServiceDefinitionLink = true;
        }
        if(Settings.getInstance().hasPrivilege('AGENCY_QUALIFICATIONS', "EXECUTE") || Settings.getInstance().hasPrivilege('AGENCY_QUALIFICATIONS', "READ")) {
            this.visibleCustomQualificationsLink = true;
        }
        if(Settings.getInstance().hasPrivilege('AGENCY_MESSAGE_SUFFIXES', "EXECUTE") || Settings.getInstance().hasPrivilege('AGENCY_QUALIFICATIONS', "READ")) {
            this.visibleMessageSuffixesLink = true;
        }
    }

    public showAgencyDefinition(): void {
        this.hideAllChildComponents();
        this.addClassToItem('agencyDefId');
        this.visibleAgencyDefinition = true;
    }
    public showServiceSummary(): void {
        this.hideAllChildComponents();
        this.addClassToItem('serviceSummaryId');
        this.visibleServiceSummary = true;
    }
    public showServiceDefinition(): void {
        this.hideAllChildComponents();
        this.addClassToItem('serviceDefId');
        this.visibleServiceDefinition = true;
    }
    public showCustomQualifications(): void {
        this.hideAllChildComponents();
        this.addClassToItem('customQualificationId');
        this.visibleCustomQualifications = true;
    }
     public showMessageSuffixes(): void {
        this.hideAllChildComponents();
        this.addClassToItem('emailSuffixesId');
        this.visibleMessageSuffixes = true;
    }

    public hideAllChildComponents() {
        this.visibleAgencyDefinition = false;
        this.visibleServiceSummary = false;
        this.visibleServiceDefinition = false;
        this.visibleCustomQualifications = false;
        this.visibleMessageSuffixes = false;

        if(this.visibleAgencyDefinitionLink) {
            this.removeClassFromItems('agencyDefId');
        }
        if(this.visibleServiceSummaryLink) {
            this.removeClassFromItems('serviceSummaryId');
        }
        if(this.visibleServiceDefinitionLink) {
            this.removeClassFromItems('serviceDefId');
        }
        if(this.visibleCustomQualificationsLink) {
            this.removeClassFromItems('customQualificationId');
        }
         if(this.visibleMessageSuffixesLink) {
            this.removeClassFromItems('emailSuffixesId');
        }
    }
    public removeClassFromItems(itemId: string): void {
        if (document.getElementById(itemId).classList.contains('selectedMenuItem') === true)
            document.getElementById(itemId).classList.remove('selectedMenuItem');

    }
    public addClassToItem(itemId: string): void {
        document.getElementById(itemId).classList.add('selectedMenuItem');
    }
}


